<template>
    <div class="p-3">
        <h4 class="text-dark">Control Center: Appointments</h4>

        <div class="row">
            <div class="col-12 col-sm-4 p-2">
                <p class="table-header text-white text-capitalize p-2">Template name</p>
                <div class="p-2">
                    <p @click="template = t" class="mb-0 text-primary" v-for="t in templates">
                        {{ t.name }}
                    </p>
                </div>
                <div class="d-flex">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        placeholder="Template Name"
                        v-model="template.name"
                    />
                    <a class="btn btn-sm btn-primary text-white font-weight-bold ml-2">ADD</a>
                </div>
            </div>
            <div class="col-12 col-sm-8 p-2">
                <div class="bg-white border-light p-3 pt-4">
                    <form>
                        <div class="form-group row">
                            <label
                                for="name"
                                class="col-4 col-form-label text-uppercase text-dark font-weight-bold"
                                >Template name</label
                            >
                            <div class="col-8">
                                <input
                                    type="text"
                                    class="form-control form-control-sm"
                                    id="name"
                                    v-model="template.name"
                                />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-6">
                                <label for="start" class="text-uppercase text-dark font-weight-bold"
                                    >Start time</label
                                >
                                <!--<input type="text" class="form-control form-control-sm" id="start">-->
                                <time-picker
                                    v-model="template.start"
                                    :options="datePickerOptions"
                                    :startHour="6"
                                    :picker-class="'form-control form-control-sm'"
                                ></time-picker>
                            </div>
                            <div class="form-group col-6">
                                <label for="end" class="text-uppercase text-dark font-weight-bold"
                                    >End time</label
                                >
                                <time-picker
                                    v-model="template.end"
                                    :options="datePickerOptions"
                                    :startHour="
                                        template.start
                                            ? moment(
                                                  template.start,
                                                  datePickerOptions.outputFormat
                                              ).hour()
                                            : 6
                                    "
                                    :startMinute="
                                        template.start
                                            ? moment(
                                                  template.start,
                                                  datePickerOptions.outputFormat
                                              ).minute()
                                            : 0
                                    "
                                    :endHour="21"
                                    :endMinute="0"
                                    :picker-class="'form-control form-control-sm'"
                                ></time-picker>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-6">
                                <label for="break" class="text-uppercase text-dark font-weight-bold"
                                    >Break time</label
                                >
                                <time-picker
                                    v-model="template.breakStart"
                                    :options="datePickerOptions"
                                    :startHour="
                                        template.start
                                            ? moment(
                                                  template.start,
                                                  datePickerOptions.outputFormat
                                              ).hour()
                                            : 6
                                    "
                                    :startMinute="
                                        template.start
                                            ? moment(
                                                  template.start,
                                                  datePickerOptions.outputFormat
                                              ).minute()
                                            : 0
                                    "
                                    :endHour="21"
                                    :picker-class="'form-control form-control-sm'"
                                ></time-picker>
                            </div>
                            <div class="form-group col-6">
                                <label
                                    for="break-duration"
                                    class="text-uppercase text-dark font-weight-bold"
                                    >Duration</label
                                >
                                <time-picker
                                    v-model="template.breakDuration"
                                    :endHour="2"
                                    :endMinute="0"
                                    :picker-class="'form-control form-control-sm'"
                                ></time-picker>
                            </div>
                        </div>
                        <p
                            class="text-right link cursor-pointer"
                            @click="breaks.push({ time: '', duration: '' })"
                        >
                            <i class="fa fa-angle-right mr-2"></i> add another break
                        </p>
                        <div class="form-row" v-for="(b, i) in breaks">
                            <div class="form-group col-6">
                                <label
                                    :for="`break-${i}`"
                                    class="text-uppercase text-dark font-weight-bold"
                                    >Break time</label
                                >
                                <time-picker
                                    v-model="breaks[i].start"
                                    :options="datePickerOptions"
                                    :startHour="
                                        template.start
                                            ? moment(
                                                  template.start,
                                                  datePickerOptions.outputFormat
                                              ).hour()
                                            : 6
                                    "
                                    :startMinute="
                                        template.start
                                            ? moment(
                                                  template.start,
                                                  datePickerOptions.outputFormat
                                              ).minute()
                                            : 0
                                    "
                                    :endHour="21"
                                    :picker-class="'form-control form-control-sm'"
                                ></time-picker>
                            </div>
                            <div class="form-group col-6">
                                <label
                                    :for="`break-duration-${i}`"
                                    class="text-uppercase text-dark font-weight-bold"
                                    >Duration</label
                                >
                                <time-picker
                                    v-model="breaks[i].duration"
                                    :endHour="2"
                                    :endMinute="0"
                                    :picker-class="'form-control form-control-sm'"
                                ></time-picker>
                            </div>
                            <p class="text-right link cursor-pointer" @click="breaks.splice(i, 1)">
                                <i class="fa fa-angle-right mr-2"></i> remove break
                            </p>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-6">
                                <label for="lunch" class="text-uppercase text-dark font-weight-bold"
                                    >Lunch time</label
                                >
                                <time-picker
                                    v-model="template.lunchStart"
                                    :options="datePickerOptions"
                                    :startHour="
                                        template.start
                                            ? moment(
                                                  template.start,
                                                  datePickerOptions.outputFormat
                                              ).hour()
                                            : 0
                                    "
                                    :startMinute="
                                        template.start
                                            ? moment(
                                                  template.start,
                                                  datePickerOptions.outputFormat
                                              ).minute()
                                            : 0
                                    "
                                    :endHour="21"
                                    :picker-class="'form-control form-control-sm'"
                                ></time-picker>
                            </div>
                            <div class="form-group col-6">
                                <label
                                    for="lunch-duration"
                                    class="text-uppercase text-dark font-weight-bold"
                                    >Duration</label
                                >
                                <time-picker
                                    v-model="template.lunchDuration"
                                    :endHour="2"
                                    :endMinute="0"
                                    :picker-class="'form-control form-control-sm'"
                                ></time-picker>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-6">
                                <label
                                    for="repeat"
                                    class="text-uppercase text-dark font-weight-bold"
                                    >Repeat</label
                                >
                                <select id="repeat" class="form-control form-control-sm">
                                    <option>Every week</option>
                                </select>
                            </div>
                            <div class="form-group col-6 d-flex flex-column justify-content-center">
                                <div class="form-check">
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        v-model="template.schedule"
                                        value="'center'"
                                        id="center-schedule"
                                    />
                                    <label
                                        class="form-check-label text-capitalize"
                                        for="center-schedule"
                                    >
                                        Follow therapy center schedule
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        v-model="template.schedule"
                                        value="'school'"
                                        id="school-schedule"
                                    />
                                    <label
                                        class="form-check-label text-capitalize"
                                        for="school-schedule"
                                    >
                                        Follow school schedule
                                    </label>
                                </div>
                            </div>
                            <div class="form-group col-6 d-flex justify-content-start">
                                <span
                                    v-for="(d, i) in ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']"
                                    :class="selectedDays[i] ? 'selected-day' : 'unselected-day'"
                                    @click="$set(selectedDays, i, !selectedDays[i])"
                                    >{{ d }}</span
                                >
                            </div>
                        </div>
                        <div class="">
                            <a
                                class="button btn-primary text-white btn-sm text-uppercase font-weight-bold p-2"
                                @click="save()"
                                >Save new template</a
                            >
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <hr
            style="width:100%;margin: 0.5rem auto;color:#bfbfbf;background: #bfbfbf; height: 1px;"
        />
        <div class="row mt-2">
            <div class="col-12 bg-white border-light m-1 p-3">
                <h4 class="text-capitalize">Schedule Replacement List Message Template</h4>
                <div class="row mt-2">
                    <div class="col-9">
                        <small class="font-weight-bold">Replacement has been found</small>
                    </div>
                    <div class="col-3"></div>
                </div>
                <div class="row">
                    <div class="col-9">
                        <textarea class="textarea w-100" rows="3"></textarea>
                    </div>
                    <div class="col-3">
                        <a
                            class="btn btn-sm btn-primary text-white font-weight-bold text-capitalize ml-2"
                            >Save message template</a
                        >
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-9">
                        <small class="font-weight-bold">Your appointment has been cancelled</small>
                    </div>
                    <div class="col-3"></div>
                </div>
                <div class="row">
                    <div class="col-9">
                        <textarea class="textarea w-100" rows="3"></textarea>
                    </div>
                    <div class="col-3">
                        <a
                            class="btn btn-sm btn-primary text-white font-weight-bold text-capitalize ml-2"
                            >Save message template</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TimePicker from "../ui/TimePicker";
export default {
    name: "Calendar",
    components: { TimePicker },
    data() {
        return {
            templates: [{ name: "Template 1" }],
            template: {
                start: null,

                start: null,
            },
            selectedDays: [false, false, false, false, false, false],
            breaks: [],
            datePickerOptions: {
                pickerFormat: "hh:mm a",
                outputFormat: "HH:mm",
                minutesInterval: 30,
            },
        };
    },
    methods: {
        save() {},
    },
};
</script>

<style scoped lang="scss">
.selected-day {
    transition: all 0.4s;
    margin-right: 0.5rem;
    min-width: 2rem;
    max-width: 2rem;
    min-height: 2rem;
    max-height: 2rem;
    cursor: pointer;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: solid 2px #38ba48;
    color: #38ba48;
}
.unselected-day {
    transition: all 0.4s;
    margin-right: 0.5rem;
    min-width: 2rem;
    max-width: 2rem;
    min-height: 2rem;
    max-height: 2rem;
    cursor: pointer;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: solid 2px #8f8f8f;
    color: #8f8f8f;
}
</style>
